/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './hospital-op-bill-item.reducer';

export const HospitalOPBillItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const hospitalOPBillItemList = useAppSelector(state => state.hospitalOPBillItem.entities);
  const loading = useAppSelector(state => state.hospitalOPBillItem.loading);
  const totalItems = useAppSelector(state => state.hospitalOPBillItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="hospital-op-bill-item-heading" data-cy="HospitalOPBillItemHeading">
        <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.home.title">Hospital OP Bill Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/hospital-op-bill-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.home.createLabel">Create new Hospital OP Bill Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.hospitalOPBillItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {hospitalOPBillItemList && hospitalOPBillItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('description')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.description">Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('description')} />
                </th>
                <th className="hand" onClick={sort('totalCost')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.totalCost">Total Cost</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalCost')} />
                </th>
                <th className="hand" onClick={sort('paidAmount')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.paidAmount">Paid Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('paidAmount')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('billType')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.billType">Bill Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billType')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('miscellaneous')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.miscellaneous">Miscellaneous</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('miscellaneous')} />
                </th>
                <th className="hand" onClick={sort('multiplier')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.multiplier">Multiplier</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('multiplier')} />
                </th>
                <th className="hand" onClick={sort('qty')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.qty">Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('qty')} />
                </th>
                <th className="hand" onClick={sort('chargedMrp')}>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.chargedMrp">Charged Mrp</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargedMrp')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.bill">Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.appointment">Appointment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.labBill">Lab Bill</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.opService">Op Service</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.pharmacyBill">Pharmacy Bill</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.order">Order</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.orderItem">Order Item</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.patientCategory">Patient Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.miscCharge">Misc Charge</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {hospitalOPBillItemList.map((hospitalOPBillItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/hospital-op-bill-item/${hospitalOPBillItem.id}`} color="link" size="sm">
                      {hospitalOPBillItem.id}
                    </Button>
                  </td>
                  <td>{hospitalOPBillItem.description}</td>
                  <td>{hospitalOPBillItem.totalCost}</td>
                  <td>{hospitalOPBillItem.paidAmount}</td>
                  <td>{hospitalOPBillItem.discount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BillType.${hospitalOPBillItem.billType}`} />
                  </td>
                  <td>{hospitalOPBillItem.active ? 'true' : 'false'}</td>
                  <td>{hospitalOPBillItem.microSec}</td>
                  <td>{hospitalOPBillItem.timestampEntry}</td>
                  <td>{hospitalOPBillItem.lastUpdated}</td>
                  <td>{hospitalOPBillItem.cursor}</td>
                  <td>{hospitalOPBillItem.miscellaneous ? 'true' : 'false'}</td>
                  <td>{hospitalOPBillItem.multiplier}</td>
                  <td>{hospitalOPBillItem.qty}</td>
                  <td>{hospitalOPBillItem.chargedMrp}</td>
                  <td>
                    {hospitalOPBillItem.bill ? (
                      <Link to={`/hospital-bill/${hospitalOPBillItem.bill.id}`}>{hospitalOPBillItem.bill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.appointment ? (
                      <Link to={`/appointments/${hospitalOPBillItem.appointment.id}`}>{hospitalOPBillItem.appointment.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.labBill ? (
                      <Link to={`/diaglab-bill/${hospitalOPBillItem.labBill.id}`}>{hospitalOPBillItem.labBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.opService ? (
                      <Link to={`/op-charge/${hospitalOPBillItem.opService.id}`}>{hospitalOPBillItem.opService.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.pharmacyBill ? (
                      <Link to={`/pharmacy-bill/${hospitalOPBillItem.pharmacyBill.id}`}>{hospitalOPBillItem.pharmacyBill.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.order ? (
                      <Link to={`/op-procedure-order/${hospitalOPBillItem.order.id}`}>{hospitalOPBillItem.order.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.orderItem ? (
                      <Link to={`/op-procedure-order-item/${hospitalOPBillItem.orderItem.id}`}>{hospitalOPBillItem.orderItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.patientCategory ? (
                      <Link to={`/patient-category/${hospitalOPBillItem.patientCategory.id}`}>{hospitalOPBillItem.patientCategory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.miscCharge ? (
                      <Link to={`/misc-charges/${hospitalOPBillItem.miscCharge.id}`}>{hospitalOPBillItem.miscCharge.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {hospitalOPBillItem.scheme ? (
                      <Link to={`/payment-scheme/${hospitalOPBillItem.scheme.id}`}>{hospitalOPBillItem.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/hospital-op-bill-item/${hospitalOPBillItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/hospital-op-bill-item/${hospitalOPBillItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/hospital-op-bill-item/${hospitalOPBillItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.hospitalOPBillItem.home.notFound">No Hospital OP Bill Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={hospitalOPBillItemList && hospitalOPBillItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default HospitalOPBillItem;
